import { useState } from 'react';
import { Button, Popover, TextButton } from 'seagull';
import { AddCircleLiner24 } from 'seagull/icons';
import { useActiveServiceTemplates } from "../../hooks/reactQuery/queries/useActiveServiceTemplates";
import { AddServicesPopover } from "./AddServicesPopover/AddServicesPopover";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function AddServicesButton(props) {
  const {
    className,
    agreementData,
    disabled,
    testId = '',
    text = 'Add services',
    variant = 'button',
    popoverHorizontalAlign = 'center',
    onClick,
    onServicesAdded
  } = props;
  useActiveServiceTemplates({
    refreshOnMount: true
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = !!anchorEl;
  function addServices(event) {
    onClick === null || onClick === void 0 || onClick();
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }
  function renderButton() {
    switch (variant) {
      case 'button':
        return /*#__PURE__*/_jsx(Button, {
          type: "button",
          disabled: disabled,
          "data-testid": testId,
          className: className,
          onClick: addServices,
          children: text
        });
      case 'textWithIcon':
        return /*#__PURE__*/_jsx(TextButton, {
          type: "button",
          className: className,
          disabled: disabled,
          underline: "none",
          weight: "normal",
          "data-testid": testId,
          prefixIcon: /*#__PURE__*/_jsx(AddCircleLiner24, {}),
          onClick: addServices,
          children: text
        });
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderButton(), /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: isOpen,
      anchorOrigin: {
        vertical: -8,
        horizontal: popoverHorizontalAlign
      },
      transformOrigin: {
        vertical: 'bottom',
        horizontal: popoverHorizontalAlign
      },
      onClose: handleClose,
      children: /*#__PURE__*/_jsx(AddServicesPopover, {
        testId: testId,
        agreementData: agreementData,
        onSelectServiceTemplate: service => {
          handleClose();
          onServicesAdded([service]);
        }
      })
    })]
  });
}